import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import AuthLayout from '@/components/AuthLayout';
import { authApi } from '@/features/auth/auth.api';
import { extractError } from '@/lib/axios';

export default function ResetPasswordPage(): JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const { register, handleSubmit, formState } = useForm<{ password: string }>();

  const onSubmit = handleSubmit(async ({ password }) => {
    try {
      await authApi.resetPassword(token, password);
      toast.success('Password reset! You can log in now.');
      navigate('/login');
    } catch (err) {
      toast.error(extractError(err).message);
    }
  });

  if (!token) {
    return (
      <AuthLayout title="Invalid link">
        <p className="text-sm text-slate-600 dark:text-slate-400">This reset link is missing or invalid.</p>
        <Link to="/forgot-password" className="btn-primary mt-4">
          Request a new link
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Choose a new password">
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="mb-1 block text-sm font-medium">New password</label>
          <input className="input" type="password" {...register('password', { required: true })} />
        </div>
        <button type="submit" className="btn-primary w-full" disabled={formState.isSubmitting}>
          {formState.isSubmitting ? 'Saving…' : 'Reset password'}
        </button>
      </form>
    </AuthLayout>
  );
}
